import { Component, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { ApiService } from 'src/app/config/api.service';
import { Banner, BannersResponse, PostLoginBannerConfig } from 'src/app/shared/interfaces/banner.interface';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { CommonService } from 'src/app/shared/services/common/common.service';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
})
export class BannerComponent implements OnDestroy {

  public isMobile: boolean = this.commonService.isDeviceMobile();
  public isLoggedIn: boolean = this._authService.isAuthenticated();
	public loadingBanners: boolean = true;
	private banners: Banner[];
	public filteredBanners: Banner[] = [];
	private destroy$: Subject<void> = new Subject<void>();
	public postLoginBannerConfig?: Partial<PostLoginBannerConfig> = {
        topBannersCarouselOptions: [
            {
                breakpoint: '1280',
                numVisible: 1.1,
                numScroll: 1,
              },
              {
                breakpoint: '991px',
                numVisible: 1.1,
                numScroll: 1,
              },
              {
                breakpoint: '767px',
                numVisible: 1.25,
                numScroll: 1,
              },
        ]
    };

  // TODO: remove once this is ready to go live
  private hardcodedBanner: Banner = {
    "id": "9234707b-132c-49a1-aa80-82632f3d03dd",
    "type": "client_banner",
    "attributes": {
        "name": "Mobile-desktop-pre-login-post-login",
        "code": "mobile-desktop-pre-login-post-login",
        "banner_url": "",
        "position": 0,
        "client_id": "e3930874-02ea-4bec-a40a-60b059973465",
        "project_id": "356b468b-cabd-45f0-9466-74f00744992e",
        "banner_image": "assets/banners/image-desk.png"
      }
    };

	constructor(
		private readonly store: Store,
		public commonService: CommonService,
    public _authService: AuthService,
    private apiService: ApiService
	) {
    commonService.changeLanguage$.subscribe(() => {
      sessionStorage.getItem("userLanguage") && this.getBanners();
    });
	}

	private getBanners(): void {
    this.apiService.getBanners({}).pipe(takeUntil(this.destroy$)).subscribe(
      (response: BannersResponse) => {
          if (response.data) {
            this.banners = response?.data
            
            this.filterPreLoginBanners();
          }
      },
      (error) => {
        // Handle errors if needed
      },
      () => {
        // Handle completion if needed
      }
    );

	}

	private filterPreLoginBanners(): void {
		this.loadingBanners = true;
		this.filteredBanners = this.banners?.filter((banner: Banner) => 
			banner.attributes.code.includes(
				this.commonService.isDeviceMobile() ? "mobile" : "desktop"
			) && banner.attributes.code.includes(this.isLoggedIn ? "post-login" : "pre-login")
		);

    // TODO: remove once this is ready to go live
    // this.filteredBanners.push(this.hardcodedBanner);
    // this.filteredBanners.reverse();
		this.loadingBanners = false;
	}

	public ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	public handleRedirection(gotoUrl: string): void {
    this.analyticsBannerClickData(gotoUrl)
    if(gotoUrl) window.open(gotoUrl, '_blank')
	}

  private analyticsBannerClickData(url: string) {
    const payload = { 
        siteSection : "content_body",
        clickPosition : 'banner', // ticker or footer_banner  
        pageURL:url, 
        button_name : "banner_img",
        linkType : "navigation" 
      } 
   this.commonService.sendAnalyticsData('home_click', 'clickInfo' ,payload)
  }
}
